module services {
    export module applicationcore {
        export class localeService implements interfaces.applicationcore.ILocaleService {
            static $inject = ["$resource", "ENV"];
            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            getLocale(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "Locale/GetLocale", {
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }
        }
    }
    angular.module("app").service("localeService", services.applicationcore.localeService);
}